module.exports = __webpack_public_path__ + "images/feature/20160722_2-9a3155fd5e71f6cfb3d6eecec64b3a97.jpg";